import { render } from "./Editproductcategory.vue?vue&type=template&id=f4015ff2&scoped=true"
import script from "./Editproductcategory.vue?vue&type=script&lang=js"
export * from "./Editproductcategory.vue?vue&type=script&lang=js"

import "./Editproductcategory.vue?vue&type=style&index=0&id=f4015ff2&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4015ff2"]])

export default __exports__